/**
 * Pure predicates for dismissing the "Reported" Filter popup (see Filter.jsx).
 *
 * The popup used to have no outside-click / Escape handling (N-221), so it stayed
 * open when another menu (e.g. the breadcrumb field selector) was opened, and the
 * two popovers coexisted and overlapped. These helpers keep the dismissal decision
 * free of DOM wiring so it can be unit-tested without a browser.
 */

// Treat a click as "outside" when the popup wrapper exists but does not contain
// the click target. A missing wrapper element means there is nothing to dismiss.
const isOutsideClick = (wrapperEl, target) => {
  if (!wrapperEl) return false;
  return !wrapperEl.contains(target);
};

// Escape keys, covering the legacy 'Esc' value some browsers still report.
const isEscapeKey = (key) => key === 'Escape' || key === 'Esc';

// The popup should close on an outside click only while it is open.
const shouldDismissOnOutsideClick = ({ isOpen, wrapperEl, target }) =>
  Boolean(isOpen) && isOutsideClick(wrapperEl, target);

module.exports = {
  isOutsideClick,
  isEscapeKey,
  shouldDismissOnOutsideClick,
};
